import React, { ReactElement } from 'react'
import {
  TestCardWrapper,
  TestCardHeader,
  TestCardDetails,
  TestDetails,
  TimeIcon
} from './subcomponents'
import { H4, Small } from '../../typography'
import { colors } from '../../const/theme'
import Button from 'react-bootstrap/Button'
import formatTime from '../../helpers/formatTime'

interface StudentTestCardProps {
  testType: string
  onSelect?: () => void
  name: string
  questionCount: number
  duration: number
  publishDateTime: number
  status: string
  disabled?: boolean
}

const StudentTestCard = ({
  testType,
  onSelect,
  name,
  questionCount,
  duration,
  publishDateTime,
  status,
  disabled
}: StudentTestCardProps): ReactElement => {
  return (
    <TestCardWrapper>
      <TestCardHeader testType={testType}>
        <H4 color={colors.white}>{name}</H4>
        <Small hasPadding={false} color={colors.white} isHelpText>
          {formatTime(publishDateTime)}
        </Small>
      </TestCardHeader>
      <TestCardDetails>
        <TimeIcon icon={['far', 'clock']} size="1x" />
        <TestDetails hasPadding>{`${duration} min`}</TestDetails>
        <TestDetails hasPadding>{`${questionCount} qts`}</TestDetails>
        <Button variant="light" onClick={onSelect} disabled={disabled}>
          {status}
        </Button>
      </TestCardDetails>
    </TestCardWrapper>
  )
}

export default StudentTestCard
